"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Theme = require("../../../Theme/Theme.variables");

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Cufflinks =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Cufflinks, _PureComponent);

  function Cufflinks() {
    _classCallCheck(this, Cufflinks);

    return _possibleConstructorReturn(this, _getPrototypeOf(Cufflinks).apply(this, arguments));
  }

  _createClass(Cufflinks, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          width = _this$props.width,
          height = _this$props.height;
      var color = (0, _Theme.variables)(this.props)[this.props.color];
      return _react.default.createElement(_IconBase.IconBase, _extends({
        width: width,
        height: height,
        className: className,
        style: style,
        viewBox: "0 0 16 15",
        version: "1.1",
        fill: "none"
      }, this.props), _react.default.createElement("title", null, "Cufflinks Icon"), _react.default.createElement("path", {
        d: "M11.5547 10.6666L11.5547 4.44434",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _react.default.createElement("path", {
        d: "M12.7407 13.3334H10.3704C9.06667 13.3334 8 12.1334 8 10.6667H15.1111C15.1111 12.1334 14.0444 13.3334 12.7407 13.3334Z",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _react.default.createElement("path", {
        d: "M8.89062 6.22217L14.224 6.22217",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _react.default.createElement("path", {
        d: "M4.44531 9.77789V3.55566",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _react.default.createElement("path", {
        d: "M3.261 0.888916H5.63137C6.93507 0.888916 8.00174 2.08892 8.00174 3.55558H0.890625C0.890625 2.08892 1.95729 0.888916 3.261 0.888916Z",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _react.default.createElement("path", {
        d: "M7.11068 8H1.77734",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    }
  }]);

  return Cufflinks;
}(_react.PureComponent);

Cufflinks.displayName = 'Cufflinks'; // Prop Types

Cufflinks.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  color: _propTypes.default.string
};
Cufflinks.defaultProps = {
  className: '',
  style: {},
  width: '16',
  height: '15',
  color: 'black'
};

var _default = (0, _styledComponents.withTheme)(Cufflinks);

exports.default = _default;